import React, { useEffect, useState } from "react";
import { useLazyCancelordersQuery, useLazyOrderallgetQuery } from "../../redux/Api/api";
import { FiTruck, FiCheckCircle, FiClock } from "react-icons/fi";

const OrderPage = () => {
    const [getAllOrders] = useLazyOrderallgetQuery();
    const [orders, setOrders] = useState([]);
    const [cancelorders] = useLazyCancelordersQuery();

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const userId = storedUser?._id;

        if (!userId || typeof userId !== "string") {
            console.error("Invalid userId:", userId);
            return;
        }

        getAllOrders(userId)
            .unwrap()
            .then((data) => {
                setOrders(data.orders);
            })
            .catch((err) => {
                console.error("Error fetching orders:", err);
            });

    }, [getAllOrders]);

    const handlecancel = (orderId) => {
        if (!orderId) return;

        cancelorders(orderId)
            .unwrap()
            .then(() => {
                setOrders((prevOrders) =>
                    prevOrders.map((order) =>
                        order._id === orderId
                            ? { ...order, status: "Cancelled", cancellationDate: new Date().toISOString() }
                            : order
                    )
                );
            })
            .catch((err) => console.log("Error canceling order:", err));
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case "Delivered":
                return <span className="bg-green-100 text-green-600 px-3 py-1 text-sm rounded-md flex items-center gap-1"><FiCheckCircle /> {status}</span>;
            case "Shipped":
                return <span className="bg-yellow-100 text-yellow-600 px-3 py-1 text-sm rounded-md flex items-center gap-1"><FiTruck /> {status}</span>;
            case "Confirmed":
                return <span className="bg-blue-100 text-blue-600 px-3 py-1 text-sm rounded-md flex items-center gap-1">✔ {status}</span>;
            case "Cancelled":
                return <span className="bg-red-100 text-red-600 px-3 py-1 text-sm rounded-md flex items-center gap-1"><FiClock /> Cancelled</span>;
            default:
                return <span className="bg-gray-100 text-gray-600 px-3 py-1 text-sm rounded-md flex items-center gap-1"><FiClock /> Pending</span>;
        }
    };

    return (
        <>
            <div className="md:max-w-auto md:mx-auto md:mt-48 mt-36">
                <div className="bg-blue-600 text-white py-6 text-center shadow-md">
                    <h1 className="text-2xl font-bold">My Orders</h1>
                    <p className="text-sm">Home ➝ Orders</p>
                </div>
            </div>

            <div className="mt-10 max-w-5xl mx-auto px-4 md:px-0 space-y-6">
                {orders.length > 0 ? (
                    orders.map((order) => (
                        <div key={order._id} className="bg-white shadow-lg rounded-lg p-6 border border-gray-200">
                            <div className="flex flex-col md:flex-row justify-between items-start md:items-center pb-4 border-b gap-4">
                                <div>
                                    <p className="text-gray-700 text-sm"><strong>Order ID:</strong> {order._id}</p>
                                    <p className="text-gray-600 text-sm"><strong>Ordered At:</strong> {new Date(order.orderedAt).toDateString()}</p>
                                </div>
                                <div className="flex flex-wrap gap-3">
                                    {getStatusBadge(order.status)}
                                    {order.status !== "Cancelled" && (
                                        <button
                                            onClick={() => handlecancel(order._id)}
                                            className="bg-red-100 text-red-400 text-sm md:text-base rounded-lg py-2 px-3 hover:bg-red-200 transition"
                                        >
                                            Cancel Order
                                        </button>
                                    )}
                                </div>

                                {order.status === "Cancelled" && order.cancellationDate && (
                                    <p className="text-red-600 text-sm">
                                        <strong>Cancelled On:</strong> {new Date(order.cancellationDate).toLocaleString()}
                                    </p>
                                )}

                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-4">
                                {order.cartItems.map((item) => (
                                    <div key={item.product._id} className="flex flex-col md:flex-row items-center md:items-start gap-6 border-b last:border-none pb-4 md:pb-0">
                                        <img
                                            src={item.product.image}
                                            alt={item.product.name}
                                            className="w-44 h-44 object-contain rounded-lg border shadow-sm"
                                        />

                                        <div className="flex-1 text-center md:text-left">
                                            <p className="text-xl font-bold text-gray-800">{item.product.name}</p>
                                            <p className="text-base text-gray-600"><strong>Price: </strong> ₹{item.product.price}</p>
                                            <p className="text-base text-gray-600"><strong>Quantity: </strong> {item.quantity}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-center text-red-500 mt-4">No orders found.</p>
                )}
            </div>
        </>
    );
};

export default OrderPage;
